<template>
  <div id="app" class="site container hfeed">
    <HeadNav selectedLanguage="en" page="disclaimer" />
    <SiteBreadcrumb />

    <div id="content" class="site-content">
      <article class="disclaimer-article">
        <section class="disclaimer-content">
          <header class="disclaimer-header">
            <h1>Disclaimer</h1>
          </header>

          <p>
            The information provided on GBAppZe is for <strong>educational and informational purposes only</strong>. We share insights,
            guides, and technical details about GBWhatsApp to help users understand its features — but we do not host,
            promote, or modify the app.
          </p>

          <section class="section">
            <h2>Accuracy of Information</h2>
            <p>While we make every effort to ensure the accuracy of our content, GBAppZe cannot guarantee that all
              information is current or error-free. Users should verify details through official or trusted sources
              before taking any action based on our content.</p>
          </section>

          <section class="section">
            <h2>Third-Party References</h2>
            <p>GBAppZe may include links or references to third-party websites for convenience. These sites operate
              independently, and we are <strong>not responsible for their content, policies, or security</strong>.</p>
          </section>

          <section class="section">
            <h2>No Official Affiliation</h2>
            <p>GBAppZe is an independent information platform. We are <strong>not associated with WhatsApp Inc. or the
              developers of GBWhatsApp</strong>. Any trademarks or names mentioned belong to their respective owners.</p>
          </section>

          <section class="section">
            <h2>Limitation of Liability</h2>
            <p>GBAppZe is not liable for any loss, damage, or data issues arising from the use of GBWhatsApp or any
              third-party applications discussed on our site. Users proceed at their own discretion and responsibility.
            </p>
          </section>

          <section class="section">
            <h2>Updates</h2>
            <p>This disclaimer may be updated periodically to reflect changes in site content or legal standards.</p>
          </section>

        </section>
      </article>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Disclaimer',
  components: { HeadNav },
};
</script>

<style scoped>
.disclaimer-article {
  display: block;
}

.disclaimer-content {
  max-width: 900px;
  margin: 2rem auto;
  padding: 24px;
  background: #fff;
  border-radius: 16px;
}

.disclaimer-header {
  text-align: center;
  margin-bottom: 24px;
}

.section {
  margin: 24px 0;
}

.section p {
  line-height: 1.7;
  color: #495057;
  font-size: 1.1em;
}

@media (max-width: 768px) {
  .disclaimer-content {
    padding: 16px;
    margin: 1rem auto;
  }
}
</style>
